// Utilities
import { make } from 'vuex-pathify';
import { toggle, set } from '../utils';
import dateFormat from '@/utils/dateFormat';
// const DEFAULT_RIGHTNAVDATA = Object.freeze({
//     color: 'primary',
//     href: false,
//     msg: '',
//     text: 'Close',
//     to: false,
//     timeout: 6000,
//     action: function () { }
// });

export const state = {
  currentVersion: process.env.VUE_APP_VERSION,
  companyName: 'Expoleap',
  now: dateFormat(new Date(), 'YYYY-MM-DD', false),
  today: dateFormat(new Date(), 'YYYY-MM-DD', false),
  type: 'month',
  focus: null,
  // typeOptions: [
  //   { text: 'Day', value: 'day' },
  //   { text: '4 Day', value: '4day' },
  //   { text: 'Week', value: 'week' },
  //   { text: 'Month', value: 'month' },
  //   { text: 'Custom Daily', value: 'custom-daily' },
  //   { text: 'Custom Weekly', value: 'custom-weekly' }
  // ],
  eventDialog: false as boolean
};

export const mutations = {
  setFocus: set('focus'),
  setType: set('type')
  // ...make.mutations(state),
  // TOGGLE_EVENT_DIALOG: toggle('eventDialog'),
  // setRightNavData: (state: any, payload: object) => {
  //     state.rightNavData = Object.assign({}, DEFAULT_RIGHTNAVDATA, payload);
  // }
};

export const actions = {
  // setDrawer: async ({ commit }: any, payload: boolean) => {
  //     commit('SET_DRAWER', payload);
  // },
  // setRightDrawer: async ({ commit }: any, payload: boolean) => {
  //     commit('SET_RIGHT_DRAWER', payload);
  // }
};

export const getters = { ...make.getters(state) };
